import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "madrid-route__content" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "madrid-route__bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_madrid_directions = _resolveComponent("madrid-directions")!
  const _component_madrid_quiz = _resolveComponent("madrid-quiz")!

  return (_ctx.route)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "madrid-route",
        style: _normalizeStyle({overflowY: _ctx.showQuiz ? 'hidden' : 'visible'})
      }, [
        _createElementVNode("div", {
          class: "madrid-route__back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
        }),
        _createElementVNode("div", {
          class: "madrid-route__image",
          style: _normalizeStyle({ backgroundImage: `url(${_ctx.route.image})` })
        }, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToMap())),
            class: "madrid-route__go"
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("span", null, "COMENZAR RUTA", -1),
            _createElementVNode("span", null, null, -1)
          ]))
        ], 4),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "DISTRITO", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.route.locations.length) + " PARADAS", 1)
          ]),
          _createElementVNode("h1", null, _toDisplayString(_ctx.route.name), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.route.description), 1),
          _createElementVNode("img", {
            src: _ctx.route.map
          }, null, 8, _hoisted_2),
          _createElementVNode("p", null, _toDisplayString(_ctx.route.description_district), 1),
          _createVNode(_component_madrid_directions, { directions: _ctx.directions }, null, 8, ["directions"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToMap())),
              class: "madrid-route__go"
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("span", null, "COMENZAR RUTA", -1),
              _createElementVNode("span", null, null, -1)
            ])),
            _cache[6] || (_cache[6] = _createElementVNode("div", null, null, -1))
          ])
        ]),
        (_ctx.showQuiz)
          ? (_openBlock(), _createBlock(_component_madrid_quiz, {
              key: 0,
              onBack: _ctx.hideQuiz,
              route: _ctx.name,
              type: _ctx.QuizType.INIT
            }, null, 8, ["onBack", "route", "type"]))
          : _createCommentVNode("", true)
      ], 4))
    : _createCommentVNode("", true)
}